<span class="status__summary-text actual-row picker">
  <mat-form-field appearance="fill" class="date-picker">
    <input
      matInput
      [matDatepicker]="picker"
      [value]="formattedDate"
      (dateChange)="changeDate($event)"
      />
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
  <!--  <mat-icon-->
  <!--    *ngIf="substatusDate?.id || substatusDate?.date"-->
  <!--    color="warn"-->
  <!--    style="cursor: pointer"-->
  <!--    matTooltip="Delete Date"-->
  <!--    (click)="deleteDateConfirmation()"-->
  <!--  >-->
  <!--    clear-->
<!--  </mat-icon>-->
@if (!slim) {
  <div class="row">
    <div class="col-md-12">
      @if (substatusDate) {
        <mat-checkbox
          (change)="changeTarget($event)"
          [checked]="substatusDate.target"
          [disabled]="substatusDate.date > today"
          >
          Target Date
        </mat-checkbox>
      }
    </div>
  </div>
}
</span>
